<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"
    app
    dark
    floating
    persistent
    mobile-break-point="991"
    width="260"
    class="pb-2"
  >
    <!-- <Snow
                color="#84C0F2"
                zIndex="0"
                speed="m"
    />-->
    <Loader :absolute="true" :loading="loading" />
    <v-img height="100%">
      <v-layout class="fill-height" tag="v-list" column>
        <v-list-tile avatar :elevation="0">
          <v-list-tile-avatar color="transparent" :elevation="0" tile="false">
            <v-img :elevation="0" :src="logo" />
          </v-list-tile-avatar>
          <div class>
            <h5 class="mb-0 mt-0 p-0">ACS Admin v.3.6.5</h5>
            <small class="mt-0" style="font-size: 10px; color: #ebebeb;" v-if="email">{{email}}</small>
          </div>
        </v-list-tile>
        <v-divider />

        <v-list-tile
          v-for="(link, i) in links"
          :key="i"
          :to="link.path"
          :active-class="color"
          avatar
          class="v-list-item"
        >
          <v-list-tile-action>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-title v-text="link.name" />
        </v-list-tile>
      </v-layout>
    </v-img>
  </v-navigation-drawer>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import Loader from "../helper/Loader";

import Snow from "vue-niege";

export default {
  components: { Loader, Snow },
  data: () => ({
    loading: true,
    logo: "./img/logo.png",
    links: [],
    responsive: false
  }),
  computed: {
    ...mapState("app", ["image", "color"]),
    inputValue: {
      get() {
        return this.$store.state.app.drawer;
      },
      set(val) {
        this.setDrawer(val);
      }
    },
    items() {
      return this.$t("Layout.View.items");
    },
    sidebarOverlayGradiant() {
      return `${this.$store.state.app.sidebarBackgroundColor}, ${this.$store.state.app.sidebarBackgroundColor}`;
    },

    email: {
      get() {
        return localStorage.getItem("email");
      }
    }
  },
  mounted() {
    this.getLinks();
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  methods: {
    ...mapMutations("app", ["setDrawer", "toggleDrawer"]),
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
    async getLinks() {
      await axios
        .get("admin/administrators/card")
        .then(response => {
          if (response.data.menu) {
            this.links = response.data.menu;
             this.$store.dispatch("menuAction",response.data.menu_keys);
             this.$store.dispatch("roleAction",response.data.role_keys);
             this.$store.dispatch("setBrand",response.data.brand_keys);
          }
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss">
#app-drawer {
  /*background-color: #121212;*/
  .v-list__tile {
    border-radius: 4px;
    &--buy {
      margin-top: auto;
      margin-bottom: 17px;
    }
  }
  .v-image__image--contain {
    top: 9px;
    height: 60%;
  }
  .search-input {
    margin-bottom: 30px !important;
    padding-left: 15px;
    padding-right: 15px;
  }
  div.v-responsive.v-image > div.v-responsive__content {
    overflow-y: auto;
  }
}
</style>
